const stringHelpers =
{
  stripLettersFromString(string) {
    return string.replace(/\D/g, '')
  },

  getNameFromEmail(email) {
    return email.slice(0, email.indexOf('@')).replace(/[.]/g, ' ').replace(/[0-9]/g, '')
  }
}

export default stringHelpers



// WEBPACK FOOTER //
// ./src/utils/stringHelpers.js